<script setup lang="ts">
type Props = {
  imgUrl: string;
  text: string;
  height?: number;
  width?: number;
  isRounded?: boolean;
};

const props = withDefaults(defineProps<Props>(), {
  height: 80,
  width: 80,
  isRounded: false,
});
</script>

<template>
  <div
    role="group"
    class="flex py-3 px-4 gap-5 items-center bg-grey-lighten-5 rounded-lg"
    :class="[props.width > 80 && 'flex-wrap sm:!flex-nowrap']"
    aria-label="Image and description"
  >
    <v-img
      cover
      alt="Tip image"
      :class="[props.isRounded && 'rounded-circle']"
      :src="props.imgUrl"
      :height="props.height"
      :width="props.width"
    />
    <p class="text-body-4 text-af-grey-700">
      {{ props.text }}
    </p>
  </div>
</template>
